import BaseController             from "controllers/base";
import PaymentStatusWidget        from "widgets/project/PaymentStatusWidget";
import InspectionListWidget       from "widgets/inspection/inspectionsListWidget";
import ChecklistCarousel          from "widgets/project/checklistCarousel";
import GenerateCertificateWidget  from "widgets/project/GenerateCertificateWidget";
import GenerateUnsignedCertificateWidget from "widgets/project/GenerateUnsignedCertificateWidget";
import DocumentUploadWidget       from "widgets/checklistItem/documentUploadWidget";
import RemoveDocumentWidget       from "widgets/checklistItem/removeDocumentWidget";
import LetterWidget               from "widgets/checklistItem/letterWidget";
import AddComplaint               from 'widgets/project/AddComplaint';
import NoticeOfIntention          from 'widgets/project/NoticeOfIntention';
import InvoiceUploadWidget        from "widgets/checklistItem/invoiceUploadWidget";
import ShareWidget                from "widgets/project/share";
import AjaxFileForm               from 'servos/ajaxFileForm';
import { placesUri }              from "servos/googlePlaces"
import { showFlashToast }         from "mixins/flash"
import ChecklistCompleteWidget    from "../../widgets/project/checklistComplete";
import EmailApprovalWidget        from "widgets/project/EmailApprovalWidget";
import { initBootstrapComponents } from "lib/bootstrapTooltips";

class Controller extends BaseController {
  call() {
    const paymentPoller = this.root.find("#payment-status-poller");
    if (paymentPoller.length) {
      new PaymentStatusWidget(paymentPoller);
      return;
    }

    bindToggleMaster.call(this);
    setActiveTab.call(this);
    bindTabPersistence.call(this);
    this.inspectionListWidget = new InspectionListWidget(this.root, '#inspection-modal-container', '#inspections-tab');
    this.checklistInspectionListWidget = new InspectionListWidget(this.root, '#checklist-inspection-modal-container', '#checklists-main-tab');

    this.inspectionListWidget.on('form-loaded', (e) => {
      this.bindInputComponents();
    })

    this.inspectionListWidget.on('item-updated', (e) => {
      bindToggleNote.call(this);
    })

    this.checklistInspectionListWidget.on('form-loaded', (e) => {
      this.bindInputComponents();
    })

    this.checklistInspectionListWidget.on('item-updated', (e) => {
      bindToggleNote.call(this);
    })

    bindShowComplaint.call(this)
    bindToggleNote.call(this)
    bindSignOff.call(this)
    bindAddToTemplate.call(this)
    // toggleDatePickerModal.call(this)

    new ShareWidget(this.root);
    new EmailApprovalWidget(this.root);

    this.root.find('.checklist-container').each((index, checklist) => {
      new GenerateCertificateWidget($(checklist));
      new GenerateUnsignedCertificateWidget($(checklist));
    })

    new ChecklistCarousel(this.root);
    this.DocumentUploadWidget = new DocumentUploadWidget(this.root);
    this.DocumentUploadWidget.on('form-loaded', (e) => {
      this.bindInputComponents()
    })

    this.DocumentUploadWidget.on('item-updated', (e) => {
      bindToggleNote.call(this)
    })

    this.RemoveDocumentWidget = new RemoveDocumentWidget(this.root);

    this.InvoiceUploadWidget = new InvoiceUploadWidget(this.root);
    this.InvoiceUploadWidget.on('form-loaded', (e) => {
      this.bindInputComponents()
    })

    this.letterWidget = new LetterWidget(this.root);
    this.letterWidget.on('form-loaded', (e) => {
      this.bindInputComponents()
    })

    this.AddComplaintWidget = new AddComplaint(this.root.find('#new-complaint'));

    this.NoticeOfIntentionWidget = new NoticeOfIntention(this.root.find('#issue-notice-of-intention'));

    bindGenerateApprovalModal.call(this);
  }
  scripts() {
    return [placesUri]
  }
};


let bindGenerateApprovalModal = function() {
  $('#generate-approval-modal').on('show.bs.modal', function (event) {
    var document_type = $(event.relatedTarget).data('document')
    $('#generate-approval-modal .modal-body p').html("This will generate a " + document_type  + " approval pdf and email out links to the following people")
    $('#generate-approval-modal .modal-body .form-group #type')[0].value = document_type
  });
}

let setActiveTab = function() {
  let tab = (new URL(location)).searchParams.get("tab");

  if (tab != null) {
    const bootstrap = window.bootstrap;
    const el = document.querySelector(`ul.proj-nav a[href="#${tab}"]`);
    if (bootstrap && el) new bootstrap.Tab(el).show();
  }
}
const bindTabPersistence = () => {
  document.querySelectorAll('ul.proj-nav a[data-bs-toggle="tab"]').forEach((el) => {
    el.addEventListener('shown.bs.tab', (e) => {
      const tab = e.target.getAttribute('href').replace('#', '');
      const url = new URL(location);

      if (tab === 'logs-tab') {
        url.searchParams.set('tab', tab);
      } else {
        url.searchParams.delete('tab');
      }

      history.replaceState(null, '', url);
    });
  });
}

let bindToggleMaster = function() {
  const masterCollapsable = document.getElementById('header-collapsable-content');
  const masterBtn = document.getElementById('toggle-header-text-btn');
  if (!masterCollapsable || !masterBtn) return;

  masterCollapsable.addEventListener('show.bs.collapse', () => {
    masterBtn.textContent = 'Hide Master';
  })

  masterCollapsable.addEventListener('hide.bs.collapse', () => {
    masterBtn.textContent = 'Show Master';
  })
}

let bindToggleNote = function() {
  const bootstrap = window.bootstrap;
  if (!bootstrap) return;

  document.querySelectorAll('.note[data-bs-toggle="popover"]').forEach((el) => {
    new bootstrap.Popover(el, { trigger: 'hover' });
  });
}

let bindSignOff = function() {
  const root = this.root;
  $(document).off('click.signOff', '.sign-off').on('click.signOff', '.sign-off', (e) => {
    let documentUrl = e.currentTarget.dataset.url
    swal({
      title: "Are you sure you want to sign off this item?",
      html: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Done`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: documentUrl,
          method: 'get',
          dataType: 'json'
        }).done((response) => {
          $((`.checklist-item[data-item-id=${response.item.id}]`)).replaceWith(response.item.html);
          initBootstrapComponents(root.find('#checklists-main-tab'));
          let checklistComplete = new ChecklistCompleteWidget(root);
        })
      }
    })
  });
}

let bindAddToTemplate = function() {
  // Delegated + namespaced binding: bind once, never re-bind on success,
  $(document).off('click.addToTemplate', '.add-to-template').on('click.addToTemplate', '.add-to-template', (e) => {
    e.preventDefault();
    const url = e.currentTarget.dataset.url;
    $.ajax({
      url: url,
      method: 'post',
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
    }).done((response) => {
      $(`tr[data-item-id="${response.item.id}"]`).replaceWith(response.item.html);
      initBootstrapComponents(document);
      showFlashToast("Item added to checklist template.", { type: "success" });
    }).fail((xhr) => {
      const message = xhr.responseJSON?.error || "Failed to add item to checklist template.";
      showFlashToast(message, { type: "error" });
    });
  });
}

let bindShowComplaint = function() {
  $('.complaint-item').on('click', (e) => {
    let complaintUrl = e.currentTarget.dataset.url
    $.ajax({
      url: complaintUrl,
      type: "GET",
      dataType: 'json',
      success: (data) => {
        $('#complaint-modal-container').html(data.html);
        const bootstrap = window.bootstrap;
        const modalEl = document.querySelector('#complaint-modal-container .modal');
        if (bootstrap && modalEl) new bootstrap.Modal(modalEl).show();
      }
    });
  });
}


export default Controller;
